import { addTraits } from 'src/api';

export const getUser = state => addTraits(state.user.user);
export const getLoginHistory = state => addTraits(state.user.loginhistory)
